import * as angular from 'angular';
import {DepotsAlerts} from "./depots-alerts.service";
import {DepotsRequests} from "./depots-requests.service";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {IQService} from "angular";


export class DepotsService {

  constructor(private depotsRequests: DepotsRequests, private depotsAlerts: DepotsAlerts, private bringozLoaderService: BringozLoaderService, private $log, private $q: IQService) {
  }

  createOne(depot) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.depotsRequests.createOne(depot)
      .then((createdDepot) => {
        this.depotsAlerts.createSuccess();
        deferred.resolve(createdDepot);
      })
      .catch((error) => {
        this.$log.error(error);
        if (error.code === 400204) {
          this.depotsAlerts.createDuplicateIdError();
        } else {
          this.depotsAlerts.createError();
        }
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  deleteDepot(id: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.depotsRequests.deleteDepot(id)
      .then((createdDepot) => {
        this.depotsAlerts.deleteSuccess();
        deferred.resolve(createdDepot);
      })
      .catch((error) => {
        this.$log.error(error);
        this.depotsAlerts.deleteError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  updateOne(depotId, depot) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.depotsRequests.updateOne(depotId, depot)
      .then((updatedDepot) => {
        this.depotsAlerts.updateSuccess();
        deferred.resolve(updatedDepot);
      })
      .catch((error) => {
        this.$log.error(error);
        this.depotsAlerts.updateError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  addBranchesToDepots(depotIds: string[], branchIds: string[]) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.depotsRequests.addBranchesToDepots(depotIds, branchIds)
      .then((depots) => {
        this.depotsAlerts.updateSuccess();
        deferred.resolve(depots);
      })
      .catch((error) => {
        this.$log.error(error);
        this.depotsAlerts.updateError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }
}

angular
  .module('bringoz.admin.depots')
  .service('depotsService', DepotsService);
